goog.provide('el8.ptdata.model.med.dcMedOrder');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.med.base');
goog.require('el8.template.ptdata.model.dcMedOrder');

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.ptdata.model.med.base);

    _class.addIntProperty("medOrderId");
    _class.addDate("discontinueDate", true);
    _class.addStringProperty("directions", true);
    _class.addStringProperty("reason", true);
    _class.addBoolean('documented', true);

    /* Helper property for carrying info up from form */
    _class.addStringProperty("manualPrescribingPhysicianName");

    /**
     * HELPER METHODS
     */
    _class.prototype.getPrescriberFullName = function() {
        return this.getPrescribingPhysicianId() ? 
            this.getPrescribingPhysicianName() : 'Prescriber Not Specified';
    };
    _class.prototype.getDescription = function() { return 'Discontinue Med Order'; };
    _class.prototype.getNotifyText = function(type) {
        if (type === "ADD_TO_NOTE") {
            return 'Discontinued med added to current note.';
        }
    };
    _class.prototype.asMap = function() {
        var mapped = el8.ptdata.model.med.base.prototype.asMap.call(this, true);
        var name = this.getManualPrescribingPhysicianName();
        if (name && (name.trim().replace(/\./g,"").toLowerCase() === 'dr')) {
            name = null;
        }
        mapped['prescribing_physician_name'] = name || null;
        return mapped;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['dcOnDocumentDate'] = el8.util.datecompare.isSameDay(
            this.getDocumentDate(), this.getDiscontinueDate());
        mapped['documentingPersonnelName'] = this.getDocumentingPersonnelName();
        mapped['documentedOtherPrescriberName'] = this.isOtherPrescriberDocumented() ?
            this.getPrescriberFullName() : null;
        mapped['supervisingPhysicianName'] = this.getSupervisingPhysicianName();
        return mapped;
    };

    /**
     * RENDERING METHODS
     */
    _class.prototype.getPatientSummary = function() {
        var soyMap = this.asSoyMap();
        var typeStr = el8.template.ptdata.model.dcMedOrder.ownedDocSummaryType(
            $.extend(soyMap, {'isPatientFriendly': true})).el8_unescape();
        var descriptionStr = el8.template.ptdata.model.dcMedOrder.ownedDocSummaryDescription(soyMap).el8_unescape();
        var otherPrescriberStr = el8.template.ptdata.model.dcMedOrder.ownedDocSummaryOtherPrescriber(soyMap).el8_unescape();

        var summaryStr = typeStr + descriptionStr + otherPrescriberStr;
        var formatting = [
            {"decoration": "tag_item", "offsets": [0, typeStr.length]}
        ];
        if (otherPrescriberStr) {
            var otherPrescriberStrStart = summaryStr.indexOf(otherPrescriberStr)+1; // +1 for {sp} at beginning
            formatting.push({
                "decoration": "light_app_color", 
                "offsets": [otherPrescriberStrStart, otherPrescriberStrStart + otherPrescriberStr.length - 1]
            });
        }
        return {
            summary: summaryStr,
            summary_formatting: formatting
        };
    };
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.model.dcMedOrder.noteSummary(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getNoteOwnedDocSummary = function(forServer) {
        /**
         * When dc order is owned by note:
         *   - If forServer=true, return the (string, formatting) pair that needs 
         *     to get sent to the server
         *    - Else, return the HTML summary
         */
        var soyMap = this.asSoyMap();
        var typeStr = el8.template.ptdata.model.dcMedOrder.ownedDocSummaryType(soyMap).el8_unescape();
        var descriptionStr = el8.template.ptdata.model.dcMedOrder.ownedDocSummaryDescription(soyMap).el8_unescape();
        var otherPrescriberStr = el8.template.ptdata.model.dcMedOrder.ownedDocSummaryOtherPrescriber(soyMap).el8_unescape();

        var summaryStr = typeStr + descriptionStr + otherPrescriberStr;
        var formatting = [
            {"decoration": "tag_item", "offsets": [0, typeStr.length]}
        ];
        if (otherPrescriberStr) {
            var otherPrescriberStrStart = summaryStr.indexOf(otherPrescriberStr)+1; // +1 for {sp} at beginning
            formatting.push({
                "decoration": "light_app_color", 
                "offsets": [otherPrescriberStrStart, otherPrescriberStrStart + otherPrescriberStr.length - 1]
            });
        }

        var result = {
            summary: summaryStr,
            summary_formatting: formatting
        };
        return forServer ? result : 
            el8.util.format(result['summary'], result['summary_formatting']);
    };


    el8.ptdata.model.med.dcMedOrder = function(spec) {
        return new _class(spec);
    };

})();

